import {
  getSummarySubTotals,
  getTotalCost,
  getTotalDeliveryAmount,
  groupByDesign,
  usePricing,
  useProject,
  useQuotedVouchers,
} from '@customink/project-service-react-components';
import { SHIPPING_TYPES } from '@customink/project-service-types';
import Big from 'big.js';

export const useOrderDiscountTotal = () => {
  const { data: project } = useProject();
  const voucherData = useQuotedVouchers();
  const { data: pricingData, isFetching, isLoading } = usePricing();

  const shippingType = project?.configuration?.shippingType;
  const projectItemsGroup = groupByDesign(project?.items || []);
  const totalDeliveryAmount = getTotalDeliveryAmount(
    projectItemsGroup,
    pricingData.grouped,
  );
  const subTotalPrice = getSummarySubTotals(pricingData.grouped);

  const totalAmountCost = getTotalCost({
    shippingType: shippingType || SHIPPING_TYPES.BULK,
    subTotalPrice,
    totalDeliveryAmount,
    numberOfAddresses: project?.distributedOrder?.numberOfAddresses,
  });

  const voucherDiscountValue = Big(voucherData?.totalDiscount || 0);
  const totalCostAfterVoucher = totalAmountCost.minus(voucherDiscountValue);

  return {
    orderTotal: totalCostAfterVoucher.toFixed(2),
    voucherDiscount: voucherDiscountValue.toFixed(2),
    isFetching,
    isLoading,
  } as const;
};
